import en from "./en"
import es from "./es"
import ca from "./ca"
import it from "./it"

export default {
	en,
	es,
	ca,
	it
}
